(function () {
  document.querySelectorAll('[data-coming-soon-success]').forEach(function (popup) {
    var closeButton = popup.querySelector('[data-coming-soon-success-close]');

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    }

    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup();
      }
    });
  });

  document.querySelectorAll('[data-coming-soon-form]').forEach(function (form) {
    var section = form.closest('.coming-soon-poster');
    var successPopup = section ? section.querySelector('[data-coming-soon-success]') : null;
    var successCloseButton = successPopup ? successPopup.querySelector('[data-coming-soon-success-close]') : null;
    var emailInput = form.querySelector('input[type="email"]');
    var consentInput = form.querySelector('input[name="marketing_consent"]');
    var submitButton = form.querySelector('button[type="submit"]');
    var publicKey = form.getAttribute('data-klaviyo-public-key');
    var listId = form.getAttribute('data-klaviyo-list');
    var source = form.getAttribute('data-klaviyo-source') || 'Coming soon';
    var shopDomain = form.getAttribute('data-shopify-shop') || '';

    function setState(text) {
      if (text) window.console.log(text);
    }

    function openSuccessPopup() {
      if (!successPopup) return;

      successPopup.classList.add('is-visible');
      successPopup.setAttribute('aria-hidden', 'false');

      if (successCloseButton) {
        successCloseButton.focus();
      }
    }

    function buildPayload(email) {
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                  properties: {
                    signup_source: source,
                    shopify_shop: shopDomain,
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      };
    }

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        return;
      }

      event.preventDefault();

      var email = emailInput.value.trim();

      if (!publicKey || !listId) {
        setState('Missing Klaviyo configuration.');
        return;
      }

      submitButton.disabled = true;
      setState('Sending...');

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          revision: '2026-04-15',
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(buildPayload(email)),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo request failed: ' + response.status);
          emailInput.value = '';
          if (consentInput) consentInput.checked = false;
          openSuccessPopup();
          setState('Subscribed.');
        })
        .catch(function () {
          setState('Subscription failed.');
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });
  });
})();
